import { Injectable } from '@angular/core';
import { ConfigService } from '../common/services/config.service';
import { HttpInterceptor } from '../common/services/httpInterceptor.service';

@Injectable()
export class OTPVerificationService {

    constructor(
        private _httpInterceptor: HttpInterceptor
    ) { }
    public PostCallEMIOTP(data) {
        const url = ConfigService.getInstance().getConfigObject().APIURL.emiOPTPost;
        return this._httpInterceptor.Post(url, data);
    }
    public GetCallService() {
        const url = ConfigService.getInstance().getConfigObject().APIURL.emiOPTPost;
        return this._httpInterceptor.Get(url);

    }
}
